export const ui = {
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    edit: 'تعديل',
    back: 'رجوع',
    loading: 'جارٍ التحميل...',
    retry: 'إعادة المحاولة',
    search: 'بحث...',
    noResults: 'لا توجد نتائج',
    create: 'إنشاء',
    add: 'إضافة',
    confirm: 'تأكيد',
    close: 'إغلاق',
    saving: 'جارٍ الحفظ...',
    required: 'مطلوب',
    actions: 'إجراءات',
    download: 'تنزيل',
    upload: 'رفع',
    import: 'استيراد',
    export: 'تصدير',
    all: 'الكل',
    yes: 'نعم',
    no: 'لا',
    or: 'أو',
  },
  connection: {
    connected: 'متصل',
    offline: 'بلا اتصال — التغييرات محفوظة محلياً',
    syncing: 'جارٍ المزامنة...',
    reconnecting: 'جارٍ إعادة الاتصال...',
    pendingChanges: (count: number) => `${count} تغييرات معلقة`,
  },
  auth: {
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    accessRevoked: 'تم إلغاء صلاحيتك',
    accessRevokedMessage: 'تم إزالتك من هذه المسابقة. يرجى التواصل مع المسؤول.',
    loginFailed: 'فشل تسجيل الدخول',
    rateLimited: 'محاولات كثيرة. يرجى الانتظار.',
    invalidLink: 'الرابط غير صالح أو منتهي الصلاحية',
    invalidLinkMessage: 'يرجى التواصل مع المسؤول للحصول على رابط جديد.',
    loggingIn: 'جارٍ تسجيل الدخول...',
    sessionExpired: 'انتهت الجلسة',
    sessionExpiredMessage: 'يرجى طلب رابط جديد من المسؤول.',
    waitingForConnection: 'في انتظار الاتصال بالشبكة',
    waitingForConnectionMessage: 'بياناتك محفوظة — سيتم المتابعة تلقائياً عند عودة الاتصال.',
  },
  students: {
    title: 'الطلاب',
    newStudent: 'طالب جديد',
    editStudent: 'تعديل الطالب',
    name: 'الاسم',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    dateOfBirth: 'تاريخ الميلاد',
    created: 'تم إضافة الطالب',
    updated: 'تم تحديث الطالب',
    deleted: 'تم حذف الطالب',
    deleteConfirm: 'هل أنت متأكد من حذف هذا الطالب؟',
    importStudents: 'استيراد طلاب',
    downloadTemplate: 'تنزيل القالب',
    noStudents: 'لا يوجد طلاب بعد',
  },
  judges: {
    title: 'المحكّمون',
    newJudge: 'محكّم جديد',
    editJudge: 'تعديل المحكّم',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
    created: 'تم إضافة المحكّم',
    updated: 'تم تحديث المحكّم',
    deleted: 'تم حذف المحكّم',
    deleteConfirm: 'هل أنت متأكد من حذف هذا المحكّم؟',
    superJudge: 'محكّم رئيسي',
    noJudges: 'لا يوجد محكّمون بعد',
  },
  competitions: {
    title: 'المسابقات',
    newCompetition: 'مسابقة جديدة',
    name: 'اسم المسابقة',
    startDate: 'تاريخ البداية',
    endDate: 'تاريخ النهاية',
    created: 'تم إنشاء المسابقة',
    updated: 'تم تحديث المسابقة',
    deleted: 'تم حذف المسابقة',
    deleteConfirm: 'هل أنت متأكد من حذف هذه المسابقة؟',
    noCompetitions: 'لا توجد مسابقات بعد',
    status: {
      draft: 'مسودة',
      published: 'منشورة',
      active: 'نشطة',
      completed: 'مكتملة',
    },
    statusTransition: {
      publish: 'نشر المسابقة',
      activate: 'بدء المسابقة',
      complete: 'إنهاء المسابقة',
      completedLabel: 'المسابقة مكتملة',
      publishConfirmTitle: 'نشر المسابقة',
      publishConfirmDescription:
        'هل أنت متأكد من نشر المسابقة؟ بعد النشر يمكن للمحكّمين تسجيل الدخول.',
      activateConfirmTitle: 'بدء المسابقة',
      activateConfirmDescription: 'هل أنت متأكد من بدء المسابقة؟ سيتمكن المحكّمون من التقييم.',
      completeConfirmTitle: 'إنهاء المسابقة',
      completeConfirmDescription: 'بعد الإنهاء، لا يمكن إعادة فتح المسابقة.',
      transitionSuccess: 'تم تحديث حالة المسابقة',
    },
    tabs: {
      settings: 'الإعدادات',
      categories: 'الفئات',
      scoringConfig: 'التقييم',
      participants: 'المشاركون',
      judges: 'المحكّمون',
      live: 'البث المباشر',
      results: 'النتائج',
      audit: 'السجل',
    },
  },
  categories: {
    title: 'الفئات',
    newCategory: 'فئة جديدة',
    name: 'اسم الفئة',
    numberOfQuestions: 'عدد الأسئلة',
    maxAge: 'الحد الأقصى للعمر',
    created: 'تم إنشاء الفئة',
    updated: 'تم تحديث الفئة',
    deleted: 'تم حذف الفئة',
    deleteConfirm: 'هل أنت متأكد من حذف هذه الفئة؟',
    noCategories: 'لا توجد فئات بعد',
    cannotDelete: 'لا يمكن حذف هذه الفئة لوجود درجات مرتبطة',
    questionsCount: (count: number) => `${count} أسئلة`,
  },
  scoringConfig: {
    title: 'إعدادات التقييم',
    stage2Metrics: 'معايير الأداء',
    mistakeTypes: 'أنواع الأخطاء',
    metricName: 'اسم المعيار',
    maxValue: 'القيمة القصوى',
    mistakeLabel: 'نوع الخطأ',
    deduction: 'الخصم',
    color: 'اللون',
    icon: 'الأيقونة',
    sumWarning: (sum: number) => `مجموع القيم القصوى: ${sum}/100`,
    sumExceeded: 'مجموع القيم القصوى يتجاوز 100',
    metricCreated: 'تم إنشاء المعيار',
    metricUpdated: 'تم تحديث المعيار',
    mistakeTypeCreated: 'تم إنشاء نوع الخطأ',
    mistakeTypeUpdated: 'تم تحديث نوع الخطأ',
    lockedMessage: 'لا يمكن تعديل إعدادات التقييم أثناء أو بعد المسابقة',
  },
  participants: {
    title: 'المشاركون',
    addParticipant: 'إضافة مشارك',
    registrationNumber: 'رقم التسجيل',
    category: 'الفئة',
    status: 'الحالة',
    importParticipants: 'استيراد مشاركين',
    enrolled: 'مسجّل',
    absent: 'غائب',
    withdrawn: 'منسحب',
    disqualified: 'مستبعد',
    activate: 'تفعيل',
    deactivate: 'إيقاف',
    noParticipants: 'لا يوجد مشاركون بعد',
    noCategoriesHint: 'أضف فئات أولاً لتتمكن من إضافة مشاركين',
    created: 'تم تسجيل المشارك',
    duplicateEnrollment: 'الطالب مسجّل بالفعل في هذه الفئة',
  },
  judgeParticipations: {
    title: 'تعيينات المحكّمين',
    addJudge: 'تعيين محكّم',
    assignedCategories: 'الفئات المعيّنة',
    generateLink: 'إنشاء رابط',
    regenerateLink: 'إعادة إنشاء الرابط',
    linkGenerated: 'تم إنشاء الرابط',
    copyLink: 'نسخ الرابط',
    linkCopied: 'تم نسخ الرابط',
    noCategoriesHint: 'أضف فئات أولاً لتتمكن من تعيين محكّمين',
    removeJudge: 'إزالة المحكّم',
    removeConfirm: 'اكتب اسم المحكّم للتأكيد. سيتم حذف جميع درجاته.',
    regenerateConfirm: 'سيتم إلغاء الرابط السابق وإنشاء رابط جديد.',
  },
  scoring: {
    submit: 'إرسال الدرجة',
    submitConfirmTitle: 'تأكيد الإرسال',
    submitConfirmMessage: 'بعد الإرسال، لا يمكن تعديل الدرجة إلا من قبل المسؤول.',
    submitted: 'تم الإرسال',
    total: 'المجموع',
    question: 'السؤال',
    stage2: 'الأداء',
    mistakes: 'الأخطاء',
    noMistakes: 'لا أخطاء',
    editMistakes: 'تعديل',
    removeLast: 'إزالة الأخير',
    inactiveQuestionWarning: 'هذا ليس السؤال الحالي',
    goToActiveQuestion: 'الانتقال إلى السؤال الحالي',
    activeQuestionLabel: 'السؤال الحالي',
    questionFailed: 'أُسقط هذا السؤال',
    failQuestion: 'إسقاط السؤال',
    failQuestionConfirm: 'تأكيد الإسقاط؟',
    unfailQuestion: 'إلغاء الإسقاط',
    nextQuestion: 'السؤال التالي',
    studentDisqualified: 'تم استبعاد هذا الطالب',
    conductorControls: 'لوحة التحكم',
    markAsCurrent: 'تعيين كسؤال حالي',
    clearCurrentQuestion: 'إلغاء تعيين السؤال الحالي',
    studentInactive: 'الطالب غير نشط حالياً',
    studentNotReciting: 'الطالب لا يتلو حالياً',
    studentNotRecitingHint: 'إذا كان يتلو، أبلغ المحكّم الرئيسي ليقوم بتفعيله',
    studentNotRecitingHintSuper: 'يمكنك بدء التلاوة لهذا الطالب من هنا',
    startReciting: 'بدء التلاوة',
    returnToCategory: 'العودة إلى الفئة',
    alreadySubmitted: 'تم إرسال هذه الدرجة',
    createScore: 'إنشاء تقييم',
    submitOnBehalf: 'تسليم',
    submitOnBehalfConfirm: 'هل تريد تسليم هذه الدرجة بدلاً من المحكّم؟',
    scoreCreated: 'تم إنشاء التقييم',
    scoreSubmittedByAdmin: 'تم تسليم الدرجة',
    scored: 'تم التقييم',
    notStarted: 'لم يبدأ',
    inProgress: 'قيد التقييم',
    greeting: (name: string) => `مرحباً، ${name}`,
    progress: (completed: number, total: number) => `${completed} من ${total}`,
    participantCount: (count: number) => `${count} مشارك`,
    noCategories: 'لا توجد فئات مخصصة لك',
    contactAdmin: 'يرجى التواصل مع المسؤول',
    outOf: (max: number) => `من ${max}`,
    questionProgress: (current: number, total: number) => `س${current} من ${total}`,
    superJudgeActions: 'إجراءات المحكّم الرئيسي',
    studentStatusOf: (name: string) => `حالة الطالب (${name})`,
    markFinished: 'انتهى من التلاوة',
    activateOffline: 'تفعيل (بدون اتصال)',
    reciting: 'يتلو الآن',
    finished: 'انتهى',
    sectionReciting: 'يتلو الآن',
    sectionPending: 'في الانتظار',
    sectionFinished: 'انتهوا',
    sectionDisqualified: 'مستبعدون',
    allJudgesDone: 'اكتمل التقييم',
    you: 'أنت',
    peerSubmitted: 'أرسل',
    peerInProgress: 'يقيّم',
    peerNotStarted: 'لم يبدأ',
  },
  live: {
    title: 'البث المباشر',
    active: 'نشط',
    pending: 'قيد الانتظار',
    done: 'مكتمل',
    overrideScore: 'تعديل الدرجة',
    viewScores: 'عرض الدرجات',
    fullScoreDetails: 'تفاصيل الدرجات الكاملة',
    noScoresYet: 'لا توجد درجات بعد',
    overrideConfirmMessage: 'سيتم تسجيل هذا التعديل في سجل الأحداث',
    overrideSuccess: 'تم تعديل الدرجة',
    activate: 'تفعيل',
    deactivate: 'إيقاف',
    activateConfirm: 'هل تريد تفعيل هذا المتسابق؟',
    deactivateConfirm: 'هل تريد إيقاف هذا المتسابق؟',
    studentActivated: 'تم تفعيل الطالب',
    studentDeactivated: 'تم إيقاف الطالب',
    disqualify: 'استبعاد',
    reinstate: 'إعادة',
    disqualifyConfirm: 'هل تريد استبعاد هذا المتسابق؟ لن يتمكن المحكّمون من تقييمه.',
    reinstateConfirm: 'هل تريد إعادة هذا المتسابق؟',
    studentDisqualified: 'تم استبعاد الطالب',
    studentReinstated: 'تم إعادة الطالب',
    skipQuestionConfirm: 'هل تريد إسقاط هذا السؤال؟',
    studentDetails: 'تفاصيل المتسابق',
    judgeScores: 'درجات المحكّمين',
    noScoreYet: 'لم يُقيّم بعد',
    printSheets: 'طباعة أوراق التقييم',
    summaryTotal: 'المجموع',
    summaryParticipants: 'متسابق',
    summaryActive: 'نشط',
    summaryCompleted: 'مكتمل',
    completedProgress: (completed: number, total: number) => `${completed} من ${total} مكتمل`,
    judgesProgress: (submitted: number, total: number) => `${submitted} من ${total} محكّمين`,
    notActive: 'المسابقة ليست نشطة بعد',
    participantCount: (count: number) => `${count} متسابق`,
  },
  results: {
    title: 'النتائج',
    rank: 'الترتيب',
    finalScore: 'الدرجة النهائية',
    judgeCount: 'عدد المحكّمين',
    exportCsv: 'تصدير CSV',
    noResults: 'لا توجد نتائج بعد',
    preliminaryResults: 'نتائج مبدئية',
    allCategories: 'الكل',
    judgesLabel: (count: number) => `${count} محكّمين`,
  },
  audit: {
    title: 'سجل الأحداث',
    actor: 'المنفّذ',
    action: 'الإجراء',
    entity: 'الكيان',
    timestamp: 'الوقت',
    details: 'التفاصيل',
    noEntries: 'لا توجد أحداث',
  },
  errors: {
    unexpected: 'حدث خطأ غير متوقع',
    networkError: 'خطأ في الاتصال',
    refreshPage: 'تحديث الصفحة',
    goHome: 'العودة للرئيسية',
    pageNotFound: 'الصفحة غير موجودة',
    pageNotFoundMessage: 'الصفحة التي تبحث عنها غير موجودة.',
  },
  import: {
    selectFile: 'اختر ملف CSV أو Excel',
    selectFileDescription: 'CSV أو Excel (.xlsx)',
    uploading: 'جارٍ الرفع...',
    importComplete: 'اكتمل الاستيراد',
    totalRows: 'إجمالي الصفوف',
    imported: 'تم الاستيراد',
    skipped: 'تم التخطي',
    errors: 'أخطاء',
    warnings: 'تحذيرات',
    row: 'الصف',
    column: 'العمود',
    uploadAnother: 'رفع ملف آخر',
    done: 'تم',
    downloadTemplate: 'تنزيل القالب',
    configureMapping: 'تهيئة الأعمدة',
    startRow: 'بداية البيانات (رقم الصف)',
    endRow: 'نهاية البيانات (رقم الصف)',
    endRowHint: 'اتركه فارغاً لاستيراد جميع الصفوف',
    dateFormat: 'صيغة التاريخ',
    columnMapping: 'ربط الأعمدة',
    skip: 'تخطي',
    name: 'الاسم',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    dateOfBirth: 'تاريخ الميلاد',
    category: 'الفئة',
    categoryStrategy: 'طريقة تحديد الفئة',
    noCategory: 'بدون فئة',
    singleCategory: 'فئة واحدة للجميع',
    categoryFromColumn: 'عمود في البيانات',
    categoryPerSheet: 'كل ورقة = فئة',
    selectCategory: 'اختر الفئة',
    selectCompetition: 'اختر المسابقة',
    validateEmail: 'التحقق من البريد الإلكتروني',
    validatePhone: 'التحقق من رقم الهاتف',
    preview: 'معاينة',
    previewing: 'جارٍ المعاينة...',
    previewResults: 'نتائج المعاينة',
    validRows: 'صفوف صالحة',
    invalidRows: 'صفوف غير صالحة',
    importNow: 'استيراد الآن',
    importing: 'جارٍ الاستيراد...',
    importSuccess: 'تم استيراد الطلاب بنجاح',
    importedCount: (count: number) => `تم استيراد ${count} طالب`,
    goToStudents: 'الذهاب إلى الطلاب',
    importMore: 'استيراد المزيد',
    sheet: 'ورقة',
    sheets: 'الأوراق',
    backToConfigure: 'تعديل الإعدادات',
    backToUpload: 'رفع ملف جديد',
    sampleData: 'عينة من البيانات',
    step: (current: number, total: number) => `الخطوة ${current} من ${total}`,
    sheetsFound: (count: number) => `تم العثور على ${count} ورقة`,
    validation: 'التحقق',
    includeSheet: 'تضمين هذه الورقة',
    sheetSettings: 'إعدادات الورقة',
    noSheetsEnabled: 'يجب تضمين ورقة واحدة على الأقل',
    globalSettings: 'إعدادات عامة',
    dataRange: 'نطاق البيانات',
    nameColumnRequired: 'يجب ربط عمود واحد على الأقل بالاسم',
    mapped: 'مربوط',
    noCategoryDesc: 'استيراد الطلاب بدون تعيين فئة',
    singleCategoryDesc: 'جميع الطلاب في نفس الفئة',
    categoryFromColumnDesc: 'تحديد الفئة من عمود في الملف',
    categoryPerSheetDesc: 'كل ورقة تمثّل فئة مختلفة',
    mapCategoryColumnFirst: 'قم بربط عمود إلى "الفئة" في إعدادات الورقة أولاً',
  },
} as const
